module.exports = __webpack_public_path__ + "static/media/WINDRIDGE bylaw document.10_2016ocx.e09a128c.pdf";